import { render, staticRenderFns } from "./AcademicIndex.vue?vue&type=template&id=1cb29756"
import script from "./AcademicIndex.vue?vue&type=script&lang=js"
export * from "./AcademicIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports